import { atom, selector } from 'recoil';
import { DriverStatus } from './../types/drivers';

export const fleetDriversReloadListState = atom<boolean>({
  key: 'app.fleet.drivers.reload',
  default: false,
});

export const fleetDriversFiltersState = atom<{
  page: number;
  search: string;
  status?: DriverStatus;
}>({
  key: 'app.fleet.drivers.filters',
  default: {
    page: 1,
    search: '',
    status: undefined,
  },
});

export const fleetDriversHasAnyFilterState = selector<boolean>({
  key: 'app.fleet.drivers.filters.any',
  get: ({ get }) => {
    const filters = get(fleetDriversFiltersState);
    const hasStatusFilter = filters.status !== undefined;

    return hasStatusFilter;
  },
});

export const fleetDriverReloadState = atom<number>({
  key: 'app.fleet.driver.reload',
  default: 0,
});
